import { css } from '@emotion/react';

export const container = css({
  marginTop: 60,
  marginBottom: 60
});

export const publisherWrapper = css({
  position: 'absolute',
  right: '10vh',
  bottom: '20vh'
});
